import { render } from "./MFileResult.vue?vue&type=template&id=1a466d86"
import script from "./MFileResult.vue?vue&type=script&lang=js"
export * from "./MFileResult.vue?vue&type=script&lang=js"

import "./MFileResult.vue?vue&type=style&index=0&id=1a466d86&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__